import callWebApi from './callWebApi';
import {
  API_OFFERING_SUBSCRIPTIONS_URL,
  API_OFFERING_SUBSCRIPTION_URL,
  replacePlaceholders,
} from './urls';

import { createFetchActionCreator } from './index';


export const OFFERING_SUBSCRIPTION_CREATE = 'OFFERING_SUBSCRIPTION_CREATE';
export const OFFERING_SUBSCRIPTION = 'OFFERING_SUBSCRIPTION';
export const OFFERING_SUBSCRIPTION_CANCEL = 'OFFERING_SUBSCRIPTION_CANCEL';


export const fetchOfferingSubscriptions = accountNumber => (dispatch, getState) => {
  const actionCreator = createFetchActionCreator(
    replacePlaceholders(API_OFFERING_SUBSCRIPTIONS_URL, { accountNumber }),
    'offeringSubscriptions',
    { accountNumber },
  )();
  return actionCreator(dispatch, getState);
};


export const createOfferingSubscription = (
  accountNumber,
  offeringId,
  requestedDollarAmount,
) => async (dispatch, getState) => {
  const { authToken } = getState();
  dispatch({ type: `${OFFERING_SUBSCRIPTION_CREATE}/REQUESTED` });

  const url = replacePlaceholders(API_OFFERING_SUBSCRIPTIONS_URL, { accountNumber });
  const body = {
    privatePlacementOfferOid: offeringId,
    requestedDollarAmount,
  };

  const { offeringSubscriptionId } = await callWebApi('POST', url, body, authToken);
  dispatch({ type: `${OFFERING_SUBSCRIPTION_CREATE}/SUCCEED`, offeringSubscriptionId });
  return offeringSubscriptionId;
};


export const fetchOfferingSubscription = (
  accountNumber,
  offeringSubscriptionId,
) => async (dispatch, getState) => {
  const { authToken } = getState();
  dispatch({ type: `${OFFERING_SUBSCRIPTION}/REQUESTED` });
  const url = replacePlaceholders(
    API_OFFERING_SUBSCRIPTION_URL,
    { accountNumber, offeringSubscriptionId },
  );
  const { offeringSubscription } = await callWebApi('GET', url, null, authToken);
  dispatch({ type: `${OFFERING_SUBSCRIPTION}/SUCCEED`, offeringSubscription });
  return offeringSubscription;
};


export const cancelOfferingSubscription = (
  accountNumber,
  offeringSubscriptionId,
) => async (dispatch, getState) => {
  const { authToken } = getState();
  dispatch({ type: `${OFFERING_SUBSCRIPTION_CANCEL}/REQUESTED` });
  const url = replacePlaceholders(
    API_OFFERING_SUBSCRIPTION_URL,
    { accountNumber, offeringSubscriptionId },
  );
  const body = { status: 'C' };
  await callWebApi('PATCH', url, body, authToken);
  dispatch({ type: `${OFFERING_SUBSCRIPTION_CANCEL}/SUCCEED` });
};



// WEBPACK FOOTER //
// ./src/actions/offeringSubscriptions.js